import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import IconButton from '../../../common/icon-button/icon-button';
import BottomSidebar from '../../../common/sidebar-bottom/bottom-sidebar.component';
import Select, { IDropdownItem } from '../../../common/select/select.component';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import { SortOptionElement } from './styles';
import { sortOptions } from '../helpers';
import { DeliveryOptionSortType } from '../../../models/delivery-options/common';
import { useStore } from '../../../stores/store';

interface Props {
  activeSortOption: IDropdownItem<DeliveryOptionSortType>;
  onSortOptionSelected: (
    sortOption: IDropdownItem<DeliveryOptionSortType>
  ) => void;
}

const DeliveryOptionsSorting = ({
  activeSortOption,
  onSortOptionSelected,
}: Props) => {
  const {
    parcelCreationStore: { isNextStepButtonLoading },
    navStore: { toggleSidebarByName },
  } = useStore();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <>
      {!isMobile ? (
        <Select
          isDisabled={isNextStepButtonLoading}
          items={sortOptions}
          value={activeSortOption}
          inputAppearence='text'
          onChange={(item: IDropdownItem<'recommended' | 'cheapest'>) =>
            onSortOptionSelected(item)
          }
        />
      ) : (
        <IconButton
          disabled={isNextStepButtonLoading}
          onClick={() => toggleSidebarByName('delivery_options_sorting')}
          appearance='text'
          aria-label='Sort'
          icon={{ glyph: 'sorting' }}
          fullWidth={false}
          className='icon-button-sorting'
        />
      )}
      {isMobile && (
        <BottomSidebar
          name='delivery_options_sorting'
          height='63.5rem'
          withBlurredBackground>
          {sortOptions.map((option) => (
            <SortOptionElement
              key={option.value}
              onClick={() => {
                onSortOptionSelected(option);
                toggleSidebarByName('delivery_options_sorting');
              }}
              $active={activeSortOption.value === option.value}>
              {t(option.label)}
            </SortOptionElement>
          ))}
        </BottomSidebar>
      )}
    </>
  );
};

export default observer(DeliveryOptionsSorting);
